var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3321 13.0527C10.1491 13.2357 9.85233 13.2357 9.66927 13.0527L4.89022 8.27361C4.70717 8.09055 4.70717 7.7938 4.89022 7.61074L5.1112 7.38974C5.29425 7.20668 5.59105 7.20668 5.77411 7.38974L10.0007 11.6164L14.2273 7.38974C14.4104 7.20668 14.7071 7.20668 14.8902 7.38974L15.1112 7.61074C15.2943 7.7938 15.2943 8.09055 15.1112 8.27361L10.3321 13.0527Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.eed732840b1eb1ce6f2d9985192842f9.svg";
export { ForwardRef as ReactComponent };